import { createUnifiedTheme, genPageTheme, palettes } from '@backstage/theme';

import { FALLBACK_FONT_STACK } from './const';

/** Classic terminal / Matrix palette: phosphor green on near-black. */
const MATRIX_GREEN = '#00ff41';
const MATRIX_GREEN_DIM = '#008f11';
const MATRIX_GREEN_SOFT = 'rgba(0, 255, 65, 0.75)';
const MATRIX_BG = '#030503';
const MATRIX_BG_ELEVATED = '#0a120a';
const MATRIX_HEADER = '#041804';

export const auraMatrixTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    type: 'dark',
    primary: {
      main: MATRIX_GREEN,
      contrastText: MATRIX_BG,
    },
    secondary: {
      main: MATRIX_GREEN_DIM,
      contrastText: MATRIX_GREEN,
    },
    error: {
      main: '#ff6b6b',
    },
    warning: {
      main: '#ffd93d',
    },
    info: {
      main: MATRIX_GREEN_SOFT,
    },
    success: {
      main: MATRIX_GREEN,
    },
    text: {
      primary: MATRIX_GREEN,
      secondary: MATRIX_GREEN_SOFT,
      disabled: 'rgba(0, 255, 65, 0.35)',
    },
    background: {
      default: MATRIX_BG,
      paper: MATRIX_BG_ELEVATED,
    },
    banner: {
      info: MATRIX_GREEN,
      error: '#ff6b6b',
      warning: '#3f3510',
      text: MATRIX_GREEN,
      link: MATRIX_GREEN,
    },
    errorBackground: '#3f1a1a',
    warningBackground: '#3f3510',
    infoBackground: '#0a1f0c',
    navigation: {
      background: MATRIX_BG,
      indicator: MATRIX_GREEN,
      color: MATRIX_GREEN_SOFT,
      selectedColor: MATRIX_GREEN,
      navItem: {
        hoverBackground: 'rgba(0, 255, 65, 0.08)',
      },
      submenu: {
        background: MATRIX_BG_ELEVATED,
      },
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '0.75rem',
          backgroundColor: MATRIX_BG_ELEVATED,
          color: MATRIX_GREEN,
          border: `1px solid ${MATRIX_GREEN_DIM}`,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardError: {
          backgroundColor: '#2a1010',
          color: '#fecaca',
          border: '1px solid #b94040',
        },
        standardWarning: {
          backgroundColor: '#2a2410',
          color: '#fde68a',
          border: '1px solid #a87311',
        },
        standardSuccess: {
          backgroundColor: '#0a1f0c',
          color: MATRIX_GREEN,
          border: `1px solid ${MATRIX_GREEN_DIM}`,
        },
        standardInfo: {
          backgroundColor: '#0a1f0c',
          color: MATRIX_GREEN_SOFT,
          border: `1px solid ${MATRIX_GREEN_DIM}`,
        },
        icon: {
          color: 'inherit',
        },
      },
    },
  },
  defaultPageTheme: 'home',
  fontFamily: `ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", ${FALLBACK_FONT_STACK}`,
  pageTheme: {
    home: genPageTheme({
      colors: [MATRIX_HEADER],
      shape: 'none',
      options: {
        fontColor: MATRIX_GREEN,
      },
    }),
    documentation: genPageTheme({
      colors: [MATRIX_HEADER],
      shape: 'none',
      options: {
        fontColor: MATRIX_GREEN,
      },
    }),
    tool: genPageTheme({
      colors: [MATRIX_HEADER],
      shape: 'none',
      options: {
        fontColor: MATRIX_GREEN,
      },
    }),
    service: genPageTheme({
      colors: [MATRIX_HEADER],
      shape: 'none',
      options: {
        fontColor: MATRIX_GREEN,
      },
    }),
    website: genPageTheme({
      colors: [MATRIX_HEADER],
      shape: 'none',
      options: {
        fontColor: MATRIX_GREEN,
      },
    }),
    library: genPageTheme({
      colors: [MATRIX_HEADER],
      shape: 'none',
      options: {
        fontColor: MATRIX_GREEN,
      },
    }),
    other: genPageTheme({
      colors: [MATRIX_HEADER],
      shape: 'none',
      options: {
        fontColor: MATRIX_GREEN,
      },
    }),
    app: genPageTheme({
      colors: [MATRIX_HEADER],
      shape: 'none',
      options: {
        fontColor: MATRIX_GREEN,
      },
    }),
    apis: genPageTheme({
      colors: [MATRIX_HEADER],
      shape: 'none',
      options: {
        fontColor: MATRIX_GREEN,
      },
    }),
  },
});
